import { CardStyle, CardStyleRadiusOption } from './model';

type CardStyleRadiusKey = 'radius-large' | 'radius-medium' | 'radius-small';

export const CARD_STYLE_RADIUS_PIXELS: Record<
  CardStyleRadiusOption,
  Record<CardStyleRadiusKey, number>
> = {
  [CardStyleRadiusOption.Radius0]: {
    'radius-large': 0,
    'radius-medium': 0,
    'radius-small': 0,
  },
  [CardStyleRadiusOption.Radius1]: {
    'radius-large': 8,
    'radius-medium': 8,
    'radius-small': 8,
  },
  [CardStyleRadiusOption.Radius2]: {
    'radius-large': 16,
    'radius-medium': 16,
    'radius-small': 16,
  },
  [CardStyleRadiusOption.Radius3]: {
    'radius-large': 40,
    'radius-medium': 32,
    'radius-small': 24,
  },
};

type CardStyleKey = 'border-width' | 'divider-width';

export const CARD_STYLE_VARIABLE_PIXELS: Record<
  CardStyle,
  Record<CardStyleKey, number>
> = {
  [CardStyle.Default]: {
    'border-width': 1,
    'divider-width': 1,
  },
  [CardStyle.Outlined]: {
    'border-width': 1,
    'divider-width': 1,
  },
  [CardStyle.Flat]: {
    'border-width': 0,
    'divider-width': 1,
  },
  [CardStyle.Edgy]: {
    'border-width': 2,
    'divider-width': 2,
  },
};
